import { BPM_PROCESS_EDITOR_PATH } from "@/modules/admin-panel/bpm-process/page/bpm-process-editor";
import { Navigate } from "react-router-dom";

/**
 * Шаблон уведомления о согласовании правится на странице BPM-процесса.
 *
 * Параметра может не быть: так бэкенд говорит «шаблон общий для нескольких
 * процессов» — тогда страница открывается как есть, со своим селектом модели.
 */
export function OpenBpmProcess() {
  const url = new URL(window.location.href);
  const modelDefinitionId = url.searchParams.get("modelDefinitionId");

  url.search = "";
  url.pathname = BPM_PROCESS_EDITOR_PATH;

  if (modelDefinitionId) {
    url.searchParams.set("modelDefinitionId", modelDefinitionId);
  }

  return <Navigate to={url.toString().replace(url.origin, "")} />;
}
